export default "__VITE_ASSET__DWvGfLXe__"